import { shouldUseMockAPI } from '@ads-bread/shared/bread/mirage';

type WindowWithFlex = Window & {
  Flex: typeof Flex;
};

declare let window: WindowWithFlex & {
  Cypress?: Record<string, string>;
  handleFromCypress?: (req: never) => Promise<never[]> | Promise<unknown>;
  STORYBOOK_ENV: string;
};

export function shouldUseMockProvider(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return Boolean(
    process.env.NEXT_PUBLIC_USE_FAKETREE?.toLowerCase() === 'true' ||
      (window.Cypress && window.handleFromCypress) ||
      window.STORYBOOK_ENV ||
      shouldUseMockAPI()
  );
}
